import { yupResolver } from '@hookform/resolvers/yup';
import { IStatesFormMeta } from '@Modules/admin/integrationSettings/containers/mixedHandlers/atm/states/statesFormMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: IStatesFormMeta;
} & TFormUIProps;

const StatesFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} my={10}>
        {displayCustomInputs<IStatesFormMeta>(
        meta,
        register,
        errors,
        isLoading
        )}
      </CC.SimpleGrid>
      
      {/* <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack> */}
    </CC.Box>
  );
};

export default StatesFormUI;
